/*
 * @Author: bbqin
 * @Date: 2022-02-17 10:14:59
 * @LastEditTime: 2023-03-10 15:42:01
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\TreeTable\Cell.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";
import { Tooltip as NCTooltip } from "@platform/base";
import { getSysFieldid } from "@platform/api";
import Hyperlink from '../Hyperlink';
const { getHyperlinkValue } = Hyperlink;

class Cell extends Component {
    constructor(props) {
        super(props);
        this.state = { tipStatus: false };
    }

    componentWillUnmount() {
        this.cellDom = null;
    }

    handleMouseOver = isFirst => {
        if (this.cellDom) {
            let { tipStatus } = this.state;
            let firstCol = this.cellDom.parentNode
                .getAttribute("class")
                .includes("first-col");
            let tipNode = null;
            let cellParent = this.cellDom.parentNode;
            let realNode = this.cellDom.querySelector(".cell-context");
            if(isFirst){
                realNode = realNode.parentNode?.parentNode;
            }
            if (cellParent) {
                tipNode = firstCol
                    ? cellParent.parentNode && cellParent.parentNode.parentNode
                    : cellParent;
            }
            if (tipNode) {
                if (
                    realNode.scrollWidth > realNode.clientWidth &&
                    tipStatus === false
                ) {
                    this.setState({ tipStatus: true });
                }
                if (
                    realNode.scrollWidth <= realNode.clientWidth &&
                    tipStatus === true
                ) {
                    this.setState({ tipStatus: false });
                }
            }
        }
    };

    render() {
        let {
            item,
            fixedStyle,
            context,
            multipleRowCell,
            searchValue,
            beforeStr,
            index,
            afterStr,
            record,
            onCellMouseDown,
            isEllipsis,
            bodyExpandAllInRow,
            colIndex,
            hyperlinkParams = {},
        } = this.props;
        let dom = <span className="cell-context">&nbsp;</span>;
        if (item.itemtype === "number") {
            dom = <span className="cell-context">{context}</span>;
        } else if (beforeStr || afterStr || searchValue) {
            dom = (
                <span className="cell-context">
                    {beforeStr}
                    {index !== -1 && !!searchValue ? (
                        <span className="table-searchable-filter">
                            {searchValue}
                        </span>
                    ) : (
                        ""
                    )}
                    {afterStr}
                </span>
            );
        }

        if (hyperlinkParams.hyperlinkflag) {
            dom = <Hyperlink
                datatype={hyperlinkParams.datatype}
                hyperlinkflag={hyperlinkParams.hyperlinkflag}
                hyperlinktype={hyperlinkParams.hyperlinktype}
                hyperlinkname={hyperlinkParams.hyperlinkname}
                hyperlinkurl={hyperlinkParams.hyperlinkurl}
                value={hyperlinkParams.dataId}
                browse={true}
                pageId={hyperlinkParams.pageId}
                areaCode={hyperlinkParams.areaCode}
                attrCode={hyperlinkParams.attrCode}
                dataId={hyperlinkParams.dataId}
                className={'hyper-link'}
            >
                {dom}
            </Hyperlink>;
        }

        if (colIndex === 0) {
            return (
                <span
                    fieldid={getSysFieldid(item.attrcode)}
                    style={fixedStyle}
                    ref={dom => {
                        this.cellDom = ReactDOM.findDOMNode(dom);
                    }}
                    onMouseOver={this.handleMouseOver.bind(this, true)}
                    onMouseDown={e => {
                        onCellMouseDown &&
                            onCellMouseDown(record, index, item.attrcode, item, e);
                    }}
                >
                    <NCTooltip
                        placement="top"
                        overlay={this.state.tipStatus ? context : ""}
                        className="tooltip-word-color"
                        delay={1}
                        inverse
                    >
                        {dom}
                    </NCTooltip>
                </span>
            );
        } else {
            return (
                <div
                    fieldid={getSysFieldid(item.attrcode)}
                    className={
                        classnames("dobule-text",
                            {
                                "dobule-text-fixed": !!(
                                    item.fixed && item.fixed === "left"
                                ),
                            }, 
                            {
                                "cell-align-right": item.itemtype === "number" || item.alignment === "right",
                                "cell-align-left": item.alignment === "left",
                                "cell-align-center": item.alignment === "center",
                            },
                        )
                    }
                    style={fixedStyle}
                    ref={dom => {
                        this.cellDom = ReactDOM.findDOMNode(dom);
                    }}
                    onMouseOver={this.handleMouseOver.bind(this, false)}
                    onMouseDown={e => {
                        onCellMouseDown &&
                            onCellMouseDown(record, index, item.attrcode, item, e);
                    }}
                >
                    <NCTooltip
                        placement="top"
                        overlay={this.state.tipStatus ? context : ""}
                        className="tooltip-word-color"
                        delay={1}
                        inverse
                    >
                        <div
                            className={classnames("double-text-cell", {
                                "single-line-and-ellipsis":
                                    !multipleRowCell && isEllipsis,
                                "three-line-and-ellipsis": !isEllipsis,
                                "mult-line-and-ellipsis":
                                    !isEllipsis && bodyExpandAllInRow,
                            })}
                        >
                            {dom}
                        </div>
                    </NCTooltip>
                </div>
            );
        }
    }
}

export default Cell;
